/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ category: NonNullable<unknown> }} Lot_Items_Choose_CategoryInputs */

const vi_lot_items_choose_category = /** @type {(inputs: Lot_Items_Choose_CategoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chọn ${i?.category}`)
};

/**

* @param {Lot_Items_Choose_CategoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_choose_category = /** @type {((inputs: Lot_Items_Choose_CategoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Choose_CategoryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_choose_category(inputs)
});